import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=4e6e8300"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoteThread: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteThread.vue').default,NoteEdit: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteEdit.vue').default,NoteCreate: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteCreate.vue').default,ErrorBlock: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ErrorBlock.vue').default})
